// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0b98dcef","239":"1796140d","453":"e736bcab","455":"90b2ce92"}[chunkId] + ".chunk.js";
};